export const routes = (prefix = `claims`) => [
    {
        path: `/${prefix}/batches`,
        name: `${prefix}.batches.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.batches.index`,
                PageDescription: "Claims: Batches report",
            },
        },
    },
    {
        path: `/${prefix}/batches/print`,
        name: `${prefix}.batches.print`,
        component: () => import('./prints/Batches.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.batches.index`,
                PageDescription: "Claims: Batches report",
            },
        },
    },
    {
        path: `/${prefix}/batches/details/print`,
        name: `${prefix}.batches.details.print`,
        component: () => import('./prints/BatchDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.batches.index`,
                PageDescription: "Claims: Batches report",
            },
        },
    },
];